export function _resolvePatientJourneyListColumnOfType_messages(column, patientJourney, row) {
    column.numUnreadMessages = row.numUnreadMessages
    column.isPrimary = row.isPrimary
}

export function _resolvePatientJourneyListColumnOfType_unreadMessageCount(column, patientJourney, row) {
    column.numUnreadMessages = row[column.id]?.count
}
